export const dbhl = 'dBHL';
export const hz = 'Hz';